exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-d3f6512a],textarea[data-v-d3f6512a]{border:1px #cecece;background:#f1f1f1;box-shadow:none}label[data-v-d3f6512a]{color:#000}", ""]);

// exports
